<template style="background-color: transparent; position:relative;">
	<StaticViewComponent :content="content"></StaticViewComponent>
</template>

<script>

import StaticViewComponent from "@/components/StaticViewComponent";

export default {
	props: {},
	metaInfo: {
		title: 'Политика конфиденциальности',
		meta: [
			{name: 'theme-color', content: '#161616'},
			{name: 'apple-mobile-web-app-capable', content: 'yes'},
			{name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent'},
			{vmid: 'description', property: 'description', content: 'Dolphin planet — Политика конфиденциальности'},
			{vmid: 'og:title', property: 'og:title', content: 'Dolphin planet — Политика конфиденциальности'},
			{vmid: 'og:description', property: 'og:description', content: 'Vue App'},
		],
	},
	components: {
		StaticViewComponent,
	},
	data() {
		return {
			content: `
			<h5 style="font-weight: bold; text-align: left;">
				Возврат денежных средств в случае отказа от посещения Мероприятия<sup style="font-size: 0.5em;">*</sup>:
			</h5>
			<br>
			<ol>
				<li>
					<p>В случае возврата билета не позднее,&nbsp;чем за&nbsp;15 (пятнадцать)&nbsp;дней до календарной
						даты
						проведения Мероприятия,&nbsp;касса Дельфинария возмещает покупателю&nbsp;100
						(сто)&nbsp;процентов от
						стоимости билета.</p>
				</li>
				<li>
					<p>В сл учае возврата билета менее чем за&nbsp;15 (пятнадцать)&nbsp;дней,&nbsp;но не
						позднее,&nbsp;чем
						за&nbsp;10 (десять)&nbsp;дней до календарной даты проведения Мероприятия,&nbsp;касса
						Дельфинария
						возмещает покупателю&nbsp;70 (семьдесят)процентов от стоимости билета.</p>
				</li>
				<li>
					<p>В случае возврата билета менее чем за&nbsp;10 (десять)&nbsp;дней,&nbsp;но не позднее,&nbsp;чем
						за&nbsp;5
						(пять)&nbsp;дней до календарной даты проведения Мероприятия,&nbsp;касса Дельфинария возмещает
						покупателю&nbsp;50 (пятьдесят)&nbsp;процентов от стоимости билета.</p>
				</li>
				<li>
					<p>В случае отказа покупателя от посещения Мероприятия без уважительных причин**&nbsp;и возврата
						билета
						менее чем за&nbsp;5 (пять)&nbsp;дней до календарной даты проведения Мероприятия,&nbsp;касса
						Дельфинария не возвращает покупателю стоимость билета.</p>
				</li>
				<li>
					<p>Покупателю предоставляется возможность произвести обмен&nbsp;(не более чем один
						раз)&nbsp;купленного
						ранее билета в срок не менее чем за&nbsp;24&nbsp;часа до календарной даты проведения
						Мероприятия на
						другую дату,&nbsp;при наличии свободных мест на Мероприятие на предполагаемую дату. </p>

					<p>Перенос осуществляется по билетам одной ценовой категории.&nbsp;В случае,&nbsp;если с момента
						приобретения покупателем билета до момента его обращения о переносе,&nbsp;произойдет изменение
						ценна мероприятие,перенос осуществляется при условии доплаты посетителем соответствующей
						разницы в
						цене.</p>
				</li>
				<li>
					<p>Билеты,&nbsp;по которым осуществлен перенос даты посещения&nbsp;&ndash;&nbsp;возврату не
						подлежат.</p>
				</li>
			</ol>
			<p>*Под Мероприятием понимаются ВСЕ шоу-программы,&nbsp;плавание с дельфинами и дельфинокоррекция.<br/>
				**Под уважительными причинами понимаются документально подтвержденные обстоятельства,&nbsp;связанные с
				болезнью либо смертью посетителя(лица,&nbsp;непосредственно приобретавшего билет на Мероприятие),&nbsp;а
				также смертью лица,&nbsp;являющегося членом его семьи или его близким родственником в соответствии с
				Семейным кодексом Российской Федерации.&nbsp;В случае отказа посетителя от посещения
				мероприятия,проводимого Дельфинарием,&nbsp;по причинам,&nbsp;связанным с болезнью,&nbsp;посетитель
				должен
				направить соответствующее уведомление на адрес электронной почты&nbsp;info@yardelfin.ru&nbsp;с
				приложением
				купленного билета не позднее даты проведения мероприятия,&nbsp;за один час до момента начала
				мероприятия.&nbsp;Впоследствии,&nbsp;при
				предоставлении посетителем документов,подтверждающих его болезнь на дату проведения
				мероприятия,&nbsp;посетителю
				осуществляется возврат денежных средств.</p>
			<p>Подтверждающие документы предоставляются не позднее&nbsp;14&nbsp;календарных дней с даты проведения
				мероприятия,&nbsp;на которое посетителем был приобретен билет. <br/>
				Если посетитель предварительно не направил уведомление о вынужденном отказе от посещения мероприятия по
				причинам,&nbsp;связанным с болезнью,&nbsp;до даты проведения мероприятия,&nbsp;возврат денежных средств
				не
				осуществляется.</p>

			<p>Обращаем Ваше внимание,&nbsp;что возврат денежных средств по причине невозможности посещения мероприятия
				в
				связи с болезнью,&nbsp;осуществляется только за билет посетителя,&nbsp;который имел уважительную
				причину и
				представил подтверждающие документы.&nbsp;В случае,&nbsp;если отказ от посещения мероприятия произошел
				вследствие болезни ребенка,&nbsp;возврат осуществляется только за два билета&nbsp;&ndash;&nbsp;билет
				ребенка
				и билет на одного из взрослых сопровождающих,&nbsp;являющегося членом его семьи.</p>
			<p>Дельфинарий оставляет за собой право вернуть Посетителю стоимость билета при возврате им билета в иных
				обстоятельствах в зависимости от сложившейся ситуации. <br/>
				В соответствии с Семейным кодексом Российской Федерации к близким родственникам относятся следующие
				категории граждан:&nbsp;дети и их родители;&nbsp;бабушки и дедушки;&nbsp;внуки и
				внучки;&nbsp;полнородные и
				не полнородные сестры и братья;&nbsp;членами семьи являются:&nbsp;супруги,&nbsp;родители и
				дети&nbsp;(усыновители
				и усыновленные).</p>
			<p>Отмена бронирования и возврат денежных средств в случае отказа от Гостиницы&nbsp;Dolphin Planet
				Hotel &amp;
				SPA:</p>
			<p>В соответствии с Федеральным законом РФ
				от&nbsp;07&nbsp;февраля&nbsp;1992&nbsp;г.&nbsp;No&nbsp;2300-1 &laquo;О
				защите прав потребителей&raquo;,&nbsp;Федеральным законом РФ&nbsp;&laquo;Об основах туристской
				деятельности в Российской
				Федерации&raquo;&nbsp;от&nbsp;24.11.1996&nbsp;г.&nbsp;No&nbsp;132-ФЗ,&nbsp;Правилами
				предоставления гостиничных услуг в Российской Федерации,&nbsp;утвержденные Постановлением
				Правительства РФ
				от&nbsp;18.11.2020&nbsp;г.&nbsp;No&nbsp;1853&nbsp;и иными нормативно-&nbsp;правовыми актами Российской
				Федерации,регулирующими сферу предоставления гостиничных
				услуг,&nbsp;Заказчик&nbsp;(потребитель)&nbsp;вправе
				в любое время отказаться от исполнения договора при условии оплаты исполнителю фактически понесенных им
				расходов.</p>

			<p>В случае,&nbsp;если Заказчиком совершено гарантированное бронирование&nbsp;&ndash;&nbsp;вид
				бронирования,&nbsp;при
				котором гостиница ожидает потребителя до расчетного часа дня,&nbsp;следующего за днем запланированного
				заезда.&nbsp;В случае несвоевременного отказа от бронирования,&nbsp;опоздания или незаезда потребителя с
				него или с заказчика взимается плата за фактический простой номера&nbsp;(места в номере),&nbsp;но не
				более
				чем за сутки.&nbsp;При опоздании более чем на сутки договор прекращается.</p>

			<p>При отмене бронирования,&nbsp;заказчику услуги необходимо направить письменное уведомление о такой
				отмене в
				Гостиницу способом,&nbsp;обеспечивающим получение Гостиницей такого уведомления.</p>

			<p>Условия использования сертификата:</p>

			<ol>
				<li>
					<p>Купить сертификат может только физическое лицо.</p>
				</li>
				<li>
					<p>Воспользоваться сертификатом может только тот</p>

					<p>человек,&nbsp;на которого он был куплен.</p>
				</li>
				<li>
					<p>При покупке сертификата нужно оплатить&nbsp;100%&nbsp;от его</p>

					<p>стоимости.</p>
				</li>
				<li>
					<p>Сертификат нельзя обменять на деньги,&nbsp;вернуть или</p>

					<p>продлить.&nbsp;По истечении срока действия он становится</p>

					<p>недействительным.</p>
				</li>
				<li>
					<p>Сертификаты можно суммировать.</p>
				</li>
				<li>
					<p>Если вы потеряли сертификат,&nbsp;его можно восстановить,</p>

					<p>связавшись со средством размещения.</p>
				</li>
				<li>
					<p>Сертификат можно использовать только один раз,&nbsp;вне</p>

					<p>зависимости от его номинала.</p>
				</li>
				<li>
					<p>Сертификат можно использовать только при</p>

					<p>бронировании без посредников на официальном сайте</p>

					<p>отеля.</p>
				</li>
				<li>
					<p>Если стоимость услуг ниже номинала сертификата,</p>

					<p>остаток денежных средств не возвращается.&nbsp;Если стоимость выше номинала
						сертификата,&nbsp;нужно
						доплатить до итоговой стоимости услуги.</p>
				</li>
				<li>
					<p>Воспользоваться сертификатом можно при наличии свободных номеров на желаемые даты,&nbsp;но не
						позднее
						даты окончания срока действия сертификата.</p>
				</li>
				<li>
					<p>Узнать о наличии свободных номеров и забронировать можно на официальном сайте отеля.</p>
				</li>
				<li>
					<p>При бронировании номера через сайт отеля напишите в комментарии к бронированию: &laquo;Прошу
						зачесть
						при заселении действующий сертификат No&lt;номер сертификата&gt;&raquo;.</p>
				</li>
			</ol>

			<p>13.&nbsp;Чтобы использовать сертификат,&nbsp;предъявите его администратору при заселении.</p>

			<p>14.&nbsp;Оплачивается полная стоимость сертификата,&nbsp;возврат невозможен.</p>
			<br>
			<h5 class="w-100 text-center">
				<a href="/application-for-refund.docx" target="_blank">
					скачать заявление на возврат
				</a>
			</h5>
			<br>
			<br>
			`,
		}
	},
	// mounted() {
	// 	this.$refs.goToTopAnchor.click()
	// },
	methods: {}
};
</script>

<style scoped>
.back_to_home_box {
	position: fixed;
	right: 15px;
	top: 55px;
	z-index: 1000;
}

.back_to_home,
.back_to_home:hover {
	color: #919191;
	text-decoration: none;
	font-size: 80px;
	line-height: 50px;
	opacity: 0.9;
	text-shadow: 0px 0px 5px black;
}

.back_to_home:hover {
	opacity: 0.5;
}

p { text-indent: 2em; }
</style>
